import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatDateDMY } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface HomeworkRow {
  id: number
  lesson_id: number
  assigned_at: string | null
  task_text: string | null
}

export function PendingHomeworksWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const items = (payload.items ?? []) as HomeworkRow[]
  const count = Number(payload.count ?? 0)

  if (count === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.pending_homeworks.empty" />
  }

  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.id} sx={{ minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MuiLink
              component={Link}
              to={ROUTES.HOMEWORKS}
              variant="body2"
              noWrap
              sx={{ flexGrow: 1, minWidth: 0 }}
            >
              {item.task_text || `#${item.id}`}
            </MuiLink>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {t('dashboard.widgets.pending_homeworks.assignedAt', {
                date: formatDateDMY(item.assigned_at),
              })}
            </Typography>
          </Box>
        </Box>
      ))}
      {count > items.length && (
        <Typography variant="caption" color="text.secondary">
          +{count - items.length}
        </Typography>
      )}
    </Stack>
  )
}
